<template>
    <v-container class="chart-container">
        <line-chart-raw :chartdata="chartdata" :options="options"></line-chart-raw>
    </v-container>
</template>
<style>
    canvas {

        width: 100% !important;

    }

    .chart-container {
        flex-grow: 1;
        min-height: 0;
        height: 300px;
    }

    .chart-container > div {
        position: relative;
        height: 100%;
    }


</style>
<script>

    import LineChartRaw from './lineChart_raw'

    export default {
        props: ['chartdata', 'options'],
        components: {
            LineChartRaw
        }


    }
</script>

<style>
</style>